import { useState } from "react";
import { Alert } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import NavigasiAdmin from "../../components/NavigasiAdmin";
import { API } from "../../config/api";

function AddProduct() {
  document.title = "Add Product";
  let navigate = useNavigate();

  const [message, setMessage] = useState("");
  //   const [categories, setCategories] = useState([]); //Store all category data
  const [categoryId, setCategoryId] = useState([]);
  const [preview, setPreview] = useState(null);

  const [form, setForm] = useState({
    image: "",
    name: "",
    desc: "",
    price: "",
    qty: "",
  });

  let { data: categories, refetch } = useQuery("categoriesCache", async () => {
    const response = await API.get("/categories");
    return response.data.data;
  });

  const handleChangeCategoryId = (e) => {
    const id = e.target.value;
    const checked = e.target.checked;

    if (checked === true) {
      setCategoryId([...categoryId, parseInt(id)]);
    } else {
      let newCategoryId = categoryId.filter((categoryIdItem) => {
        return categoryIdItem !== id;
      });
      setCategoryId(newCategoryId);
    }
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]:
        e.target.type === "file" ? e.target.files : e.target.value,
    });

    if (e.target.type === "file") {
      let url = URL.createObjectURL(e.target.files[0]);
      setPreview(url);
    }
  };

  const handleSubmit = useMutation(async (e) => {
    try {
      e.preventDefault();

      if (!form.image) {
        const alert = (
          <Alert variant="warning" className="py-1 mb-5">
            Masukkan gambar !
          </Alert>
        );
        setMessage(alert);
      }

      // Store data with FormData as object
      const formData = new FormData();
      formData.set("image", form?.image[0], form?.image[0]?.name);
      formData.set("name", form.name);
      formData.set("desc", form.desc);
      formData.set("price", form.price);
      formData.set("qty", form.qty);
      formData.set("categoryId", categoryId);

      // Configuration
      const config = {
        headers: {
          "Content-type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.token,
        },
      };

      // Insert product data
      const response = await API.post("/product", formData, config);
      console.log(response);
      navigate("/product");
    } catch (error) {
      const alert = (
        <Alert variant="danger" className="py-1">
          {error.response.data.message || error.response.data.error.message}
        </Alert>
      );
      setMessage(alert);
      console.log(error);
    }
  });

  return (
    <>
      <NavigasiAdmin active="product" />
      <div className="edit-product-section container my-3">
        <p className="my-5 fw-bold">Add Product</p>
        <form onSubmit={(e) => handleSubmit.mutate(e)}>
          {message && message}
          {preview && (
            <div>
              <img
                src={preview}
                style={{
                  maxWidth: "150px",
                  maxHeight: "150px",
                  objectFit: "cover",
                  marginBottom: 50,
                }}
                alt="preview"
              />
            </div>
          )}
          <div className="image-div mb-4">
            <label htmlFor="image" className="label-image w-100">
              <span className="me-4 btn-upload-image">Upload Image</span>
              <span>Choose Image</span>
            </label>
            <input
              type="file"
              name="image"
              id="image"
              className="form-control bg-black text-white mb-4"
              hidden
              onChange={handleChange}
            />
          </div>
          <input
            type="text"
            name="name"
            className="form-control bg-dark mb-4 text-white"
            placeholder="Name Product"
            onChange={handleChange}
          />
          <textarea
            rows="4"
            className="form-control bg-dark mb-4 text-white"
            name="desc"
            placeholder="Description Product"
            onChange={handleChange}
          ></textarea>
          <input
            type="text"
            name="price"
            className="form-control bg-dark mb-4 text-white"
            placeholder="Price (Rp.)"
            onChange={handleChange}
          />
          <input
            type="text"
            name="qty"
            className="form-control bg-dark mb-4 text-white"
            placeholder="Stock"
            onChange={handleChange}
          />
          <div className="card-form-input mt-4 px-2 py-1 pb-2 mb-4">
            <div className="text-secondary mb-1" style={{ fontSize: "15px" }}>
              Category
            </div>
            {categories?.map((item) => (
              <label className="checkbox-inline me-4" key={item.id}>
                <input
                  type="checkbox"
                  value={item.id}
                  onClick={handleChangeCategoryId}
                />{" "}
                {item.name}
              </label>
            ))}
          </div>
          <button className="btn btn-success fw-bold w-100 mb-5">Save</button>
        </form>
      </div>
    </>
  );
}

export default AddProduct;
